import * as Models from "../Models";
import * as Common from "../Common/modules";

export interface IWeatherStationApiClient {
    getWeatherStations: () => ng.IPromise<Array<Models.WeatherStation.WeatherStation.IWeatherStation>>;
}

export class WeatherStationApiClient implements IWeatherStationApiClient {
    public static $inject = ['igs.apiClientService'];

    constructor(private igsApiClientService: Common.ApiClientService.Igs.Common.IApiClientService) {
    }

    public getWeatherStations = (): ng.IPromise<Array<Models.WeatherStation.WeatherStation.IWeatherStation>> => {
        return this.igsApiClientService.get("WeatherStation/WeatherStations");
    }
}